/**
 * Text & Tabs Vue Component
 * ------------------------------------------------------------------------------
 * Main template in sections/index__text-and-tabs-horizontal.liquid & sections/index__text-and-tabs-vertical.liquid
 */
import VueTabs from './vue-tabs.vue'
import VueTab from './vue-tab.vue'

export default {
  components: {
    VueTabs,
    VueTab
  },
  data () {
    return {}
  },
  methods: {}
}
